{
  "modal_message": "Do you have the Gucci App?",
  "modal_yes": "YES",
  "modal_no": "NO"
}
